export default "__VITE_ASSET__BjJ$fVBB__"